module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_photowedding-9fb995febba66279acc84826a96c6b96.webp";